export default __webpack_public_path__ + "static/media/avatar_5.744ce04e.png";